import { Navigate, Route, Routes } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout.jsx';
import RequireAuth from './components/RequireAuth.jsx';
import Login from './pages/Login.jsx';
import Verify from './pages/Verify.jsx';
import Overview from './pages/Overview.jsx';
import Calls from './pages/Calls.jsx';
import CallDetail from './pages/CallDetail.jsx';
import Settings from './pages/Settings.jsx';
import Pricing from './pages/Pricing.jsx';
import Help from './pages/Help.jsx';
import Faq from './pages/Faq.jsx';
import Legal from './pages/Legal.jsx';
import Book from './pages/Book.jsx';
import Campaigns from './pages/Campaigns.jsx';
import CampaignDetail from './pages/CampaignDetail.jsx';
import Lists from './pages/Lists.jsx';
import ListDetail from './pages/ListDetail.jsx';
import DoNotCall from './pages/DoNotCall.jsx';
import Demonstrations from './pages/Demonstrations.jsx';
import CallRouting from './pages/CallRouting.jsx';
import Sales from './pages/Sales.jsx';
import Employee from './pages/Employee.jsx';
import Customers from './pages/Customers.jsx';
import FreightBroker from './pages/FreightBroker.jsx';
import DemoCallers from './pages/DemoCallers.jsx';
import Tasks from './pages/Tasks.jsx';
import Contacts from './pages/Contacts.jsx';
import ConferenceCalls from './pages/ConferenceCalls.jsx';
import OutboundCalls from './pages/OutboundCalls.jsx';
import ExpertContexts from './pages/ExpertContexts.jsx';
import IntegrationsSettings from './pages/IntegrationsSettings.jsx';
import Templates from './pages/Templates.jsx';
import Pitches from './pages/Pitches.jsx';
import Leads from './pages/Leads.jsx';
import CarrierSetup from './pages/trucking/CarrierSetup.jsx';
import TruckingDispatch from './pages/trucking/Dispatch.jsx';
import RepPhone from './pages/RepPhone.jsx';
import Subscribers from './pages/Subscribers.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/book" element={<Book />} />
      <Route path="/:kind" element={<Legal />} />

      <Route
        element={
          <RequireAuth>
            <DashboardLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Overview />} />
        {/* Three pillars — the primary structure of the admin. */}
        <Route path="call-routing" element={<CallRouting />} />
        <Route path="sales" element={<Sales />} />
        {/* Every business in a follow-up stage, across all campaigns. */}
        <Route path="leads" element={<Leads />} />
        <Route path="employee" element={<Employee />} />
        {/* Executive-Admin (chief-of-staff) surfaces — task-first + contact directory.
            Reachable for all tenants; the sidebar only foregrounds them for tenants
            with features.executiveAdmin. */}
        <Route path="tasks" element={<Tasks />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="conference-calls" element={<ConferenceCalls />} />
        {/* Care-line scheduling + the record of what Alfred actually dialled.
            Reachable for every tenant; only the family-care template puts it in
            the sidebar, and the page says plainly when there's no schedule. */}
        <Route path="outbound-calls" element={<OutboundCalls />} />
        <Route path="expert-mode" element={<ExpertContexts />} />
        <Route path="calls" element={<Calls />} />
        <Route path="calls/:id" element={<CallDetail />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="campaigns/:id" element={<CampaignDetail />} />
        <Route path="demonstrations" element={<Demonstrations />} />
        <Route path="lists" element={<Lists />} />
        <Route path="lists/:id" element={<ListDetail />} />
        <Route path="do-not-call" element={<DoNotCall />} />
        <Route path="subscribers" element={<Subscribers />} />
        <Route path="rep-phone" element={<RepPhone />} />
        <Route path="settings" element={<Settings />} />
        <Route path="settings/integrations" element={<IntegrationsSettings />} />
        {/* Owner-only customer provisioning. The page itself redirects
            non-owners; the server enforces owner-only on every route. */}
        <Route path="customers" element={<Customers />} />
        {/* Owner-only Freight Broker dispatch surface (the page itself redirects
            non-owners). Stage-1 informational/config view. */}
        <Route path="freight-broker" element={<FreightBroker />} />
        {/* Owner-only (#29) retired-demo caller messages. Page redirects non-owners. */}
        <Route path="demo-callers" element={<DemoCallers />} />
        {/* Shared pitch bundles. Hides itself until core ships /pitches. */}
        <Route path="pitches" element={<Pitches />} />
        <Route path="templates" element={<Templates />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="help" element={<Help />} />
      </Route>

      {/* Trucking surfaces. Authenticated, but OUTSIDE DashboardLayout: each ships its
          own header and its own nav, so nesting them would stack two of each. Both are
          still running on seed data and say so at the top of the page. */}
      <Route
        path="/trucking/setup"
        element={<RequireAuth><CarrierSetup /></RequireAuth>}
      />
      <Route
        path="/trucking/dispatch"
        element={<RequireAuth><TruckingDispatch /></RequireAuth>}
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
